export default __webpack_public_path__ + "static/media/gif-vire-documento.288452f2.gif";